import React from 'react';

const SupportBox = (props) => {
    return (
          <div className="support-box">
              <div className="support-box-header">
                  <span>Ticket - {props?.data?.id}</span>

                  <button onClick={() => {
                      props?.setType(props?.data?.status)
                      props?.setViewModal(true)
                      props?.getItem(props?.data?.id)
                  }}>
                      <img src="/icon/verdotlight.svg" alt="..."/>
                  </button>
              </div>
              <div className="support-box-content">
                  <p>
                      {props?.data?.title}
                  </p>
              </div>
              {
                  props?.data?.image_url?.length > 0 && props?.data?.image_url !== "null"
                  ?
                      <img src={props?.data?.image_url} alt="..." className="ticket-img"/>
                      :
                      ""
              }

          </div>
    );
};

export default SupportBox;